import React, {
  forwardRef,
  useState,
  useImperativeHandle,
} from 'react';
import {
  Row,
  Col,
  Modal,
  Form,
  Input,
  Radio,
  Button,
  message,
  InputNumber,
} from 'antd';
import {
  ApartmentOutlined,
  UploadOutlined,
  // BlockOutlined,
} from '@ant-design/icons';
import {
  MyUpload,
  MyTree,
} from 'components';
import { controllerDC } from 'controller';

const tab1Style = {
  height: '487px',
  position: 'relative',
};
const treeHeight = 476;
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const tailLayout = {
  wrapperCol: { offset: 4, span: 20 },
};

function ManageCategoryModal(props, ref) {
  const [currentLabel, setCurrentLabel] = useState({});
  const [currentSet, setCurrentSet] = useState({});
  const [visible, setVisible] = useState(false);
  const [childFlag, setChildFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [treeParams, setTreeParams] = useState({ labelSetId: currentSet.id || undefined });
  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    showModal: (data) => {
      setVisible(true);
      setCurrentSet(data || {});
      setTreeParams({ labelSetId: data.id || undefined });
    },
  }));
  const getCategoryDetail = (id) => {
    controllerDC.label.detail({ id }).then(res => {
      if (res.code === __SUCCESS200__) {
        const data = res.data || {};
        setCurrentLabel(data);
        form.setFieldsValue({
          name: data.name,
          code: data.code,
          sort: data.sort,
          labelPicUrl: data.labelPicUrl ? [
            {
              uid: '-1',
              name: 'image.png',
              status: 'done',
              fileId: undefined,
              url: data.labelPicUrl,
            },
          ] : [],
        });
      } else {
        message.error(res.message);
      }
    });
  };
  const onFinish = (values) => {
    console.log('Success:', values);
    const params = {
      ...values,
      labelPicUrl: values.labelPicUrl && values.labelPicUrl.length > 0 ? values.labelPicUrl[0].url : '',
      parentId: childFlag ? currentLabel.id : currentLabel.parentId || 0, // 顶级传0
      id: childFlag ? undefined : (currentLabel.id || undefined), // 不为空就是修改
      isRadio: childFlag ? currentLabel.isRadio : values.isRadio,
      labelType: 2, // 类型：1-分类；2-标签
      labelSetId: currentSet.id,
      labelSetName: currentSet.name,
    };
    controllerDC.label.saveOrUpdate(params).then(res => {
      if (res.code === __SUCCESS200__) {
        !!res.data && !!res.data.id && getCategoryDetail(res.data.id); // 更新当前标签详情
        setTreeParams(prevState => {}); // 更新标签树
        setTreeParams({ ...treeParams }); // 更新标签树
        form.resetFields();
        setEditFlag(false);
        setChildFlag(false);
      } else {
        message.error(res.message);
      }
    });
  };
  const onCancel = () => {
    setEditFlag(false);
    setChildFlag(false);
    form.setFieldsValue({
      name: currentLabel.name,
      code: currentLabel.code,
      sort: currentLabel.sort,
      isRadio: currentLabel.isRadio,
      labelPicUrl: currentLabel.labelPicUrl ? [
        {
          uid: '-1',
          name: 'image.png',
          status: 'done',
          fileId: undefined,
          url: currentLabel.labelPicUrl,
        },
      ] : [],
    });
  };
  const onModalCancel = () => {
    form.resetFields();
    setVisible(false);
    setEditFlag(false);
    setChildFlag(false);
    setCurrentLabel({});
  };
  const deleteNode = () => {
    controllerDC.label.delete({ labelType: currentLabel.labelType, id: currentLabel.id }).then(res => {
      if (res.code === __SUCCESS__ || res.code === __SUCCESS200__) {
        form.resetFields();
        setEditFlag(true);
        setCurrentLabel({});
        setTreeParams(prevState => {}); // 更新标签树
        setTreeParams({ ...treeParams }); // 更新标签树
        message.success("操作成功")
      }else{
        message.error(res.message)
      }
    });
  };
  const addRootNode = () => {
    form.resetFields();
    setEditFlag(true);
    setCurrentLabel({});
  };
  const addChildNode = () => {
    form.resetFields();
    setEditFlag(true);
    setChildFlag(true);
  };
  const handleCategorySelect = (data) => {
    console.log('debug handleCategorySelect: ', data);
    setCurrentLabel(data);
    setEditFlag(false);
    setChildFlag(false);
    form.setFieldsValue({
      name: data.name,
      code: data.code,
      sort: data.sort,
      isRadio: data.isRadio,
      labelPicUrl: data.labelPicUrl ? [
        {
          uid: '-1',
          name: 'image.png',
          status: 'done',
          fileId: undefined,
          url: data.labelPicUrl,
        },
      ] : [],
    });
  };
  const modalProps = {
    // title: <span>标签集名称: <a>{currentSet.name} <BlockOutlined /></a></span>,
    title: <span>标签集名称: <a>{currentSet.name}</a></span>,
    visible,
    width: 1000,
    cancelText: '取消',
    okButtonProps: { type: 'danger' },
    okText: '确认',
    footer: null,
    onCancel: onModalCancel,
  };
  const myTreeProps = {
    treeType: 'label',
    keyField: 'id',
    titelField: 'name',
    params: treeParams,
    onSelect: handleCategorySelect,
    treeProps: { height: treeHeight, defaultExpandAll: true, selectedKeys: currentLabel.id ? [currentLabel.id] : [] },
  };
  const myUploadProps = {
    maxWidth: 118,
    maxHeight: 95,
    maxSize: 1,
    maxCount: 1,
    antdUploadProps: {
      listType: 'picture',
      showUploadList: { showRemoveIcon: editFlag },
    },
  };
  return <Modal {...modalProps}>
    <Row gutter={40}>
      <Col span={10}>
        <div className="page-content-title">
          <span><ApartmentOutlined /> 标签树</span>
          <span>
            <Button size="small" onClick={() => addRootNode()}>新增根标签</Button>
            &emsp;
            {(!!currentLabel.id && !currentLabel.parentId) &&
            <Button size="small" onClick={() => addChildNode()}>新增子标签</Button>}
          </span>
        </div>
        <div className="border-1" style={tab1Style}>
          <MyTree {...myTreeProps} />
        </div>
      </Col>
      <Col span={14}>
        <div className="page-content-title right-box">
          <span>{childFlag ? '父节点：' : ''}{currentLabel.name}</span>
          <span>
            {!!currentLabel.id && <Button size="small" onClick={() => deleteNode()}>删除</Button>}
            &emsp;
            {(!editFlag && !childFlag && !!currentLabel.id) &&
            <Button size="small" onClick={() => setEditFlag(true)}>编辑</Button>}
          </span>
        </div>
        <div className="border-1 pd20" style={tab1Style}>
          {!editFlag && <div className="mask">&nbsp;</div>}
          <Form
            {...layout}
            form={form}
            name="basic"
            hideRequiredMark={!editFlag}
            onFinish={onFinish}
          >
            <Form.Item
              label="名称"
              name="name"
              rules={[
                { required: true, message: '请输入名称' },
                { type: 'string', max: 50, message: '不超过50个字符' },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="编码"
              name="code"
              rules={[
                { required: true, message: '请输入编码' },
                { type: 'string', max: 20, message: '不超过20个字符' },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="isRadio"
              label="是否单选"
              hidden={childFlag}
              rules={[
                { required: !childFlag, message: '请选择是否单选' },
              ]}>
              <Radio.Group>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label="排序"
              name="sort"
              rules={[{ required: true, message: '请输入排序' }]}
            >
              <InputNumber min={0} />
            </Form.Item>

            <Form.Item
              name="labelPicUrl"
              label="标签图片"
              extra={editFlag ? '建议图片大小：118px * 95px；图片格式jpg、png、jpeg；图片大小小于1M (只能保存一张图片)' : null}
            >
              <MyUpload {...myUploadProps}>
                {editFlag && <Button>
                  <UploadOutlined /> 点击上传
                </Button>}
              </MyUpload>
            </Form.Item>

            {editFlag && <Form.Item {...tailLayout}>
              <Button htmlType="submit" type="danger">
                保存
              </Button>
              <Button htmlType="button" style={{ margin: '0 8px' }} onClick={onCancel}>
                取消
              </Button>
            </Form.Item>}
            {/*<div style={{display: editFlag ? 'block' : 'none'}}>
             <Form.Item {...tailLayout}>
             <Button htmlType="submit" type="danger">
             保存
             </Button>
             <Button htmlType="button" style={{ margin: '0 8px' }} onClick={onCancel}>
             取消
             </Button>
             </Form.Item>
             </div>*/}
          </Form>
        </div>
      </Col>
    </Row>
  </Modal>;
}

export default forwardRef(ManageCategoryModal);
